export default {
  path: 'marketing',
  name: 'marketing',
  component: () => import('@/views/marketing/index.vue'),
  meta: {
    locale: '营销管理',
    requiresAuth: true,
    icon: 'icon-send',
    roles: ['super', 'admin', 'service'],
  },
  children: [
    {
      path: 'hub',
      name: 'marketingHub',
      component: () => import('@/views/marketing/hub/index.vue'),
      meta: { locale: '营销中心', requiresAuth: true, roles: ['super', 'admin'] },
    },
    {
      path: 'send-message',
      name: 'marketingSendMessage',
      component: () => import('@/views/marketing/send-message/index.vue'),
      meta: { locale: '群发私信', requiresAuth: true, roles: ['super', 'admin'] },
    },
    {
      path: 'send-coupon',
      name: 'marketingSendCoupon',
      component: () => import('@/views/marketing/send-coupon/index.vue'),
      meta: { locale: '群发优惠券', requiresAuth: true, roles: ['super', 'admin'] },
    },
    {
      path: 'send-diamond',
      name: 'marketingSendDiamond',
      component: () => import('@/views/marketing/send-diamond/index.vue'),
      meta: { locale: '群发福利钻石', requiresAuth: true, roles: ['super', 'admin'] },
    },
    {
      path: 'tag-manage',
      name: 'marketingTagManage',
      component: () => import('@/views/marketing/tag-manage/index.vue'),
      meta: { locale: 'TAG管理', requiresAuth: true, roles: ['super'] },
    },
    {
      path: 'coupon-log-list',
      name: 'marketingCouponLogList',
      component: () => import('@/views/manage/coupon-log-list/index.vue'),
      meta: { locale: '优惠券领用记录', requiresAuth: true, roles: ['super', 'admin', 'service'] },
    },
    {
      path: 'voice-idle',
      name: 'marketingVoiceIdle',
      component: () => import('@/views/marketing/voice-idle/index.vue'),
      meta: { locale: '语音频道闲置', requiresAuth: true, roles: ['super', 'admin'] },
    },
  ],
};
